import { Button, Card, CardContent, Grid, Hidden, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { formatDateTime } from "@utils/dateFormat";
import { DynamicLink } from "./DynamicLink";
import { useAlert } from "./hook/useAlert";
import { IAlert } from "./interface/IAlert";
import { VariantCardActions } from "./VariantCardActions";

interface IParams {
    alert: IAlert;
    getAlertList(): Promise<void>;
}

export const Alert = (props: IParams) => {
    const { t } = useTranslation("common");

    const { alert, getAlertList } = props;
    const { id, createdAt, iconName, navLink, navLinkLabel, message } = alert;
    const alertDate = formatDateTime(createdAt);

    const { removeAlert, removeAlertState, isLoading } = useAlert(id, getAlertList);

    let iconSrc;
    try {
        iconSrc = require(`../../static/img/icons/${iconName}.svg`);
    } catch (e) {}

    return (
        <Card className="alerts-page-card" elevation={2}>
            <CardContent>
                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={1} xs={2}>
                        <Grid container justifyContent="center">
                            {iconName && <img alt={iconName} className="alerts-page-card__icon" src={iconSrc} />}
                        </Grid>
                    </Grid>
                    <Grid item md={8} sm={7} xs={10}>
                        <Typography variant="normal">{message}</Typography>
                        <Typography color="primary" variant="normal">
                            {alertDate}
                        </Typography>
                    </Grid>
                    <Hidden xsDown>
                        <Grid item sm={3} xs={12}>
                            <Grid
                                alignItems="center"
                                className="alerts-page-card__actions"
                                container
                                justifyContent="flex-end"
                                spacing={4}
                            >
                                <Grid item md={7} sm={8} xs={6}>
                                    <DynamicLink link={navLink}>
                                        <Button color="secondary" fullWidth variant="contained">
                                            {navLinkLabel}
                                        </Button>
                                    </DynamicLink>
                                </Grid>
                                <Grid item md="auto" sm={1}>
                                    <IconButton
                                        aria-label="Delete"
                                        className="alerts-page-card__deleteButton"
                                        onClick={removeAlert}
                                    >
                                        <DeleteIcon color="primary" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Grid>
            </CardContent>
            {removeAlertState.error && (
                <Typography align="center" className="alerts-page-card__error" color="error" gutterBottom variant="h5">
                    {removeAlertState.error.errorMessage || t("genericError")}
                </Typography>
            )}
            <Hidden smUp>
                <VariantCardActions>
                    <Grid item xs={6}>
                        <Button aria-label="Delete" color="primary" fullWidth variant="contained" onClick={removeAlert}>
                            <DeleteIcon />
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <DynamicLink link={navLink}>
                            <Button color="secondary" fullWidth variant="contained">
                                {navLinkLabel}
                            </Button>
                        </DynamicLink>
                    </Grid>
                </VariantCardActions>
            </Hidden>
            {isLoading && <AbsoluteLoader size={40} />}
        </Card>
    );
};
